import en from './en.json';
import it from './it.json';
const translations = {
	en: en,
	it: it,
};
export default translations;
